/**
 * WordPress dependencies
 */
import { DropdownMenu } from '@safe-wordpress/components';
import { useSelect } from '@safe-wordpress/data';
import { _x } from '@safe-wordpress/i18n';

/**
 * External dependencies
 */
import { store as NAB_SEGMENTS } from '@nab/segmentation-rules';
import type { SegmentationRule, SegmentationRuleTypeName } from '@nab/types';

/**
 * Internal dependencies
 */
import './style.scss';
import { SegmentationRuleTypeCategory } from '../segmentation-rule-type-category';

export type SegmentationRuleTypeCategoryListProps = {
	readonly createSegmentationRule: ( type: SegmentationRuleTypeName ) => void;
	readonly segmentationRules: ReadonlyArray< SegmentationRule >;
};

export const SegmentationRuleTypeCategoryList = ( {
	createSegmentationRule,
	segmentationRules,
}: SegmentationRuleTypeCategoryListProps ): JSX.Element => {
	const segmentationRuleTypeCategories = useSegmentationRuleTypeCategories();
	return (
		<DropdownMenu
			className="nab-segmentation-rule-type-new"
			icon={ null }
			label={ _x( 'Add Rule', 'command', 'nelio-ab-testing' ) }
			toggleProps={ {
				variant: 'secondary',
				children: _x( 'Add Rule', 'command', 'nelio-ab-testing' ),
			} }
			popoverProps={ {
				className: 'nab-segmentation-rule-type-new__list',
				placement: 'top-center',
			} }
			children={ ( { onClose } ) =>
				segmentationRuleTypeCategories.map( ( category ) => (
					<SegmentationRuleTypeCategory
						key={ category.name }
						category={ category }
						createSegmentationRule={ createSegmentationRule }
						segmentationRules={ segmentationRules }
						onClose={ onClose }
					/>
				) )
			}
		/>
	);
};

// =====
// HOOKS
// =====

const useSegmentationRuleTypeCategories = () =>
	useSelect(
		( select ) =>
			select( NAB_SEGMENTS ).getSegmentationRuleTypeCategories() || [],
		[]
	);
